<!-- Header da Pagina (full width, acima das colunas) -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-shopping-cart"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'fornecedor-compra.texts.realizar_compra' | translate }}</h1>
    <p class="header-subtitle">{{ 'fornecedor-compra.texts.subtitulo' | translate }}</p>
  </div>
</div>

<!-- Layout de duas colunas - sem scroll na pagina -->
<div class="compra-layout">

  <!-- ============================================================= -->
  <!-- COLUNA ESQUERDA - Formulario e Tabela de Itens -->
  <!-- ============================================================= -->
  <div class="coluna-esquerda">

    <!-- Card Dados da Nota + Fornecedor (compacto) -->
    <div class="form-card card-compacto">
      <div class="card-content compact-content">
        <div class="form-grid compact-grid">

          <!-- Fatura Legal -->
          <div class="form-field fatura-check">
            <label class="form-label" for="faturaLegal">{{ 'fornecedor-compra.labels.fatura_legal' | translate }}</label>
            <div class="checkbox-group">
              <div class="checkbox-item">
                <p-checkbox [(ngModel)]="faturaLegal" value="faturaLegal" inputId="faturaLegal" (onChange)="onFaturaLegalChange()"></p-checkbox>
              </div>
            </div>
          </div>
          <div class="form-field numero-nf-field">
            <label class="form-label">{{ 'fornecedor-compra.labels.numero_nf' | translate }}</label>
            <div class="numero-nf-group">
              <input type="text" pInputText maxlength="3" [class.input-field-disabled]="!isFaturaLegal"
                [disabled]="!isFaturaLegal" [(ngModel)]="notaForm.numeroFilial"
                placeholder="000" class="numero-nf-input numero-nf-small" />
              <span class="numero-nf-separator">—</span>
              <input type="text" pInputText maxlength="3" [class.input-field-disabled]="!isFaturaLegal"
                [disabled]="!isFaturaLegal" [(ngModel)]="notaForm.numeroPontoExpedicao"
                placeholder="000" class="numero-nf-input numero-nf-small" />
              <span class="numero-nf-separator">—</span>
              <input type="text" pInputText maxlength="7" [class.input-field-disabled]="!isFaturaLegal"
                [disabled]="!isFaturaLegal" [(ngModel)]="notaForm.numeroFatura"
                placeholder="0000000" class="numero-nf-input numero-nf-large" />
            </div>
          </div>
          <div class="form-field fatura-input">
            <label class="form-label">{{ 'fornecedor-compra.labels.data_da_nota' | translate }}</label>
            <p-calendar [(ngModel)]="notaForm.dataDeCompra" dateFormat="dd/mm/yy" styleClass="w-full"></p-calendar>
          </div>

        </div>

        <!-- Linha Fornecedor -->
        <div class="form-grid compact-grid mt-fornecedor">
          <div class="form-field full">
            <label class="form-label fornecedor-label-row">
              <span>
                <i class="pi pi-users label-icon contact-color"></i>
                {{ 'fornecedor-compra.labels.selecionar_fornecedor' | translate }} (F3)
                <span class="required">*</span>
              </span>
              <span class="atalho-novo-fornecedor" (click)="showAddFornecedor(true)">
                {{ 'fornecedor-compra.labels.novo_fornecedor_atalho' | translate }} <kbd>F9</kbd>
              </span>
            </label>

            <!-- Dialog Adicionar Fornecedor -->
            <app-pessoa-adicionar-dialog
              [(visible)]="visibleAddFornecedor"
              tipo="fornecedor"
              (pessoaCriada)="onFornecedorCriado($event)"
              (pessoaVinculada)="addFornecedor($event)">
            </app-pessoa-adicionar-dialog>

            <div class="dialog-actions">
              <app-entity-selector #fornecedorSelector
                [config]="fornecedorSelectorConfig"
                [(value)]="selectedFornecedor"
                (entitySelected)="addFornecedor($event)"
                (addNew)="showAddFornecedor(true)"
                (dialogOpened)="activeDropdown = 'fornecedor'"
                (dialogClosed)="activeDropdown = null">
              </app-entity-selector>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Produto (input de selecao) -->
    <div class="form-card card-compacto">
      <div class="card-content compact-content">
        <div class="form-grid compact-grid">
          <div class="form-field full">
            <label class="form-label">
              <i class="pi pi-box label-icon address-color"></i>
              {{ 'fornecedor-compra.labels.selecionar_produto' | translate }} (F3)
              <span class="required">*</span>
            </label>

            <!-- Dialog Produto -->
            <p-dialog
              [(visible)]="visibleSelectItems"
              [showHeader]="false"
              [modal]="true"
              [closable]="false"
              [draggable]="false"
              styleClass="dialog-wave-redesign"
              [style]="{ width: '95vw', maxWidth: '1400px', maxHeight: '90vh' }"
              [contentStyle]="{ 'overflow': 'auto' }">

              <div class="dialog-wave-header dialog-wave-header--info ps-header-compact">
                <div class="dialog-wave-header-content">
                  <div class="dialog-wave-icon-container">
                    <i class="pi pi-search" aria-hidden="true"></i>
                  </div>
                  <div class="dialog-wave-header-text">
                    <h2>{{ 'fornecedor-compra.labels.selecionar_item' | translate }}</h2>
                  </div>
                </div>
                <button pButton icon="pi pi-times" class="p-button-rounded p-button-text ps-btn-fechar"
                  (click)="showSelectItems(false)"></button>
                <svg class="dialog-wave-svg" viewBox="0 0 1200 20" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M0,10 C150,20 350,0 500,10 C650,20 850,0 1000,10 C1100,16 1150,10 1200,10 L1200,20 L0,20 Z" fill="white"/>
                </svg>
              </div>

              <div class="dialog-wave-body">
                <app-produto-selecionar *ngIf="visibleSelectItems" [itemDeNota]="itemParaEditar"
                  [pessoaId]="selectedFornecedor?.id"
                  (visibleChange)="showSelectItems($event)" (selectedItem)="addItems($event)"
                  (updatedItem)="updateItem($event)">
                </app-produto-selecionar>
              </div>
            </p-dialog>

            <div class="dialog-actions">
              <button pButton type="button" icon="pi pi-search" class="p-button-outlined w-full"
                [label]="'fornecedor-compra.placeholders.selecionar_produto' | translate"
                (click)="showSelectItems(true)"
                style="justify-content: flex-start; text-align: left;">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabela de Itens (com scroll interno) -->
    <div class="tabela-itens-container">
      <!-- Estado vazio -->
      <div *ngIf="selectedItems.length == 0" class="empty-state-tabela">
        <i class="pi pi-inbox empty-state-icon"></i>
        <span>{{ 'fornecedor-compra.spans.nenhum_produto_selecionado' | translate }}</span>
      </div>

      <!-- Tabela com itens -->
      <div *ngIf="selectedItems.length > 0" class="tabela-itens-scroll">
        <p-table [value]="selectedItems" [tableStyle]="{'min-width': '100%'}" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'fornecedor-compra.table_headers.hash' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.imagem' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.codigo' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.barras' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.nome' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.quantidade' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.valor_unitario' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.custo_total' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.preco_venda' | translate }}</th>
              <th>{{ 'fornecedor-compra.table_headers.acoes' | translate }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-selected let-rowIndex="rowIndex">
            <tr>
              <td>{{ rowIndex + 1 }}</td>
              <td>
                <img class="product-image product-image--clicavel"
                  [src]="env.imgHost + '/' + idEmpresa + '/item/' + selected.item.imagem"
                  [alt]="selected.item.nome" (error)="onImageError($event)"
                  role="button" tabindex="0"
                  pTooltip="{{ 'fornecedor-compra.tooltips.ver_imagens' | translate }}" tooltipPosition="top"
                  (click)="abrirImagensDoItem(selected.item)"
                  (keydown.enter)="abrirImagensDoItem(selected.item)" />
              </td>
              <td>{{ selected.itemDeNotaDTO.item?.codigoItem }}</td>
              <td>{{ selected.itemDeNotaDTO.item?.barras }}</td>
              <td>{{ selected.itemDeNotaDTO.item?.nome }}</td>
              <td>{{ selected.itemDeNotaDTO.quantidade }}</td>
              <td>{{ formatarValorMonetario(selected.itemDeNotaDTO.custoUnitario) }}</td>
              <td>{{ formatarValorMonetario((selected.itemDeNotaDTO.custoUnitario * selected.itemDeNotaDTO.quantidade)) }}</td>
              <td>{{ formatarValorMonetario(selected.itemDeNotaDTO.novoPrecoVenda) }}</td>
              <td>
                <div class="table-actions">
                  <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm action-btn edit-btn"
                    pTooltip="{{ 'fornecedor-compra.tooltips.editar' | translate }}" tooltipPosition="top"
                    (click)="showSelectItems(true, selected)"></button>
                  <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm action-btn delete-btn"
                    pTooltip="{{ 'fornecedor-compra.tooltips.excluir' | translate }}" tooltipPosition="top"
                    (click)="removerItem(selected)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

  </div>

  <!-- ============================================================= -->
  <!-- COLUNA DIREITA - Resumo e Pagamento -->
  <!-- ============================================================= -->
  <div class="coluna-direita">
    <div class="resumo-container">

      <!-- Quantidade de Itens e Subtotal -->
      <div class="resumo-section resumo-totais">
        <div class="resumo-linha">
          <span class="resumo-label">{{ 'fornecedor-compra.spans.quantidade_itens' | translate }}</span>
          <span class="resumo-badge">{{ selectedItems.length }}</span>
        </div>
        <div class="resumo-linha">
          <span class="resumo-label">{{ 'fornecedor-compra.spans.subtotal' | translate }}</span>
          <span class="resumo-valor">{{ formatarValorMonetario(getTotalProdutos()) }}</span>
        </div>
      </div>

      <!-- Total -->
      <div class="resumo-section resumo-total-destaque">
        <span class="total-label">{{ 'fornecedor-compra.spans.total' | translate }}</span>
        <span class="total-valor">{{ formatarValorMonetario(getTotalCompra()) }}</span>
      </div>

      <!-- Observacao -->
      <div class="resumo-section">
        <div class="resumo-section-header">
          <i class="pi pi-comment"></i>
          <span>{{ 'fornecedor-compra.labels.observacao' | translate }}</span>
        </div>
        <textarea rows="3" pInputTextarea class="w-full resumo-textarea"
          placeholder="{{ 'fornecedor-compra.placeholders.observacoes_complementares' | translate }}"
          [(ngModel)]="notaForm.observacao"></textarea>
      </div>

      <!-- Botoes de Acao -->
      <div class="resumo-actions">
        <button pButton [label]="('fornecedor-compra.botoes.cancelar' | translate) + ' (Ctrl+Shift+Del)'"
          severity="secondary" icon="pi pi-arrow-left" class="btn-secondary w-full"
          pTooltip="Ctrl+Shift+Delete" tooltipPosition="top"
          (click)="abrirConfirmacaoCancelarPedido()"></button>
        <button pButton [label]="('fornecedor-compra.botoes.fazer_pedido' | translate) + ' (Ctrl+Enter)'"
          icon="pi pi-check" (click)="finalizarPedido()" class="btn-primary w-full"
          pTooltip="Ctrl+Enter" tooltipPosition="top"></button>
      </div>

    </div>
  </div>

</div>

<!-- Dialog Forma de Pagamento (Componente reutilizavel) -->
<!-- moedaNota: a moeda da compra eh sempre a moeda padrao da empresa (fornecedor-compra nao permite escolher moeda da nota) -->
<app-forma-pagamento-dialog
  [(visible)]="mostrarDialogPagamento"
  [totalAPagar]="getTotalCompra()"
  [moedaNota]="moedaPadrao?.enum"
  [config]="{
    formasPermitidas: ['dinheiro', 'conta', 'prazo'],
    moedaPadrao: moedaPadraoISO,
    habilitarMultiMoeda: true,
    cotacoes: { cotUSD: cotUSD, cotPYG: cotPYG, cotBRL: cotBRL, cotPesoGuarani: cotPesoGuarani, cotRealGuarani: cotRealGuarani },
    labelBotaoConfirmar: ('fornecedor-compra.botoes.fazer_pedido' | translate),
    iconeBotaoConfirmar: 'pi pi-check'
  }"
  [contas]="contasFormatadas"
  [processando]="processandoCompra"
  (confirmar)="onPagamentoConfirmado($event)"
  (cancelar)="fecharDialogPagamento()">
</app-forma-pagamento-dialog>

<!-- Dialogo Fatura Pos-Compra -->
<p-dialog
  [(visible)]="mostrarDialogoFatura"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [focusOnShow]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '650px', 'max-height': '95vh' }">

  <!-- HEADER WAVE (success) -->
  <div class="dialog-wave-header dialog-wave-header--success">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-check-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'fornecedor-compra.dialogs.fatura_gerada' | translate }}</h2>
        <p>{{ 'fornecedor-compra.dialogs.fatura_gerada_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO -->
  <div class="dialog-wave-body" *ngIf="!carregandoFatura && notaCarregada">

    <!-- Informacoes do Fornecedor -->
    <div class="fatura-dialog-section">
      <div class="fatura-dialog-section-label">
        <i class="pi pi-users"></i>
        {{ 'fornecedor-compra.dialogs.informacoes_fornecedor' | translate }}
      </div>
      <div class="fatura-dialog-pessoa">
        {{ notaCarregada.pessoa_id }} - {{ notaCarregada.nomePessoa }}
      </div>
    </div>

    <!-- Ticket + Data -->
    <div class="fatura-dialog-ticket">
      <span class="fatura-dialog-ticket-badge">
        <i class="pi pi-ticket"></i>
        TICKET # {{ notaCarregada.codigoNota }}
      </span>
      <span class="fatura-dialog-ticket-date">
        <i class="pi pi-calendar"></i>
        {{ formatarDataEHoraDialog(notaCarregada.emissaoFatura) }}
      </span>
    </div>

    <!-- Tabela de Itens -->
    <div class="fatura-dialog-section">
      <div class="fatura-dialog-section-label">
        <i class="pi pi-list"></i>
        {{ 'fornecedor-compra.dialogs.itens_da_nota' | translate }}
      </div>
      <table class="fatura-dialog-table" *ngIf="itensCarregados.length > 0">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'fornecedor-compra.table_headers.imagem' | translate }}</th>
            <th>{{ 'fornecedor-compra.dialogs.artigo' | translate }}</th>
            <th class="text-right">{{ 'fornecedor-compra.table_headers.quantidade' | translate }}</th>
            <th class="text-right">{{ 'fornecedor-compra.table_headers.custo_total' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of notaCarregada.itemDeNota; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <img *ngIf="itensCarregados[i]?.imagem"
                class="fatura-dialog-item-img"
                [src]="env.imgHost + '/' + idEmpresa + '/item/' + itensCarregados[i].imagem"
                [alt]="itensCarregados[i].nome"
                (error)="onImageError($event)" />
            </td>
            <td>{{ itensCarregados[i] ? itensCarregados[i].nome : '---' }}</td>
            <td class="text-right">{{ item.quantidade }}</td>
            <td class="text-right">{{ formatarValorDialog(item.valorTotal, notaCarregada.moeda) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Resumo Financeiro -->
    <div class="fatura-dialog-resumo">
      <div class="fatura-dialog-resumo-line">
        <span>{{ 'fornecedor-compra.spans.subtotal' | translate }}</span>
        <span>{{ formatarValorDialog(notaCarregada.valorTotal, notaCarregada.moeda) }}</span>
      </div>
      <div class="fatura-dialog-resumo-total">
        <span>{{ 'fornecedor-compra.spans.total' | translate }}</span>
        <span>{{ formatarValorDialog(notaCarregada.valorTotalComDesconto, notaCarregada.moeda) }}</span>
      </div>
    </div>

    <!-- Pagamento -->
    <div class="fatura-dialog-pagamento">
      <div class="fatura-dialog-pagamento-header">
        <i class="pi pi-wallet"></i>
        <span>{{ formatarCondicaoPagamento(notaCarregada.condicaoDePagamento) }}</span>
        <span *ngIf="!notaCarregada.numeroParcelas" class="fatura-dialog-badge-cash">
          {{ 'fornecedor-compra.dialogs.em_efetivo' | translate }}
        </span>
        <span *ngIf="notaCarregada.numeroParcelas" class="fatura-dialog-badge-parcelas">
          {{ notaCarregada.numeroParcelas }}X
        </span>
      </div>
    </div>

    <!-- Observacao -->
    <div *ngIf="notaCarregada.observacao" class="fatura-dialog-observacao">
      <i class="pi pi-comment"></i>
      <span>{{ notaCarregada.observacao }}</span>
    </div>

    <!-- Formato de Impressao -->
    <div class="fatura-dialog-formato-impressao">
      <div class="fatura-dialog-formato-header">
        <i class="pi pi-print"></i>
        <span>{{ 'fornecedor-compra.dialogs.formato_impressao' | translate }}</span>
      </div>
      <div class="formato-impressao-opcoes">
        <div class="p-field-radiobutton">
          <p-radioButton name="formatoImpressaoCompra" value="A4"
            [(ngModel)]="opcaoImpressaoFatura" inputId="compra-fmt-a4">
          </p-radioButton>
          <label for="compra-fmt-a4">A4</label>
        </div>
        <div class="p-field-radiobutton">
          <p-radioButton name="formatoImpressaoCompra" value="BOBINA_58"
            [(ngModel)]="opcaoImpressaoFatura" inputId="compra-fmt-58">
          </p-radioButton>
          <label for="compra-fmt-58">{{ 'fornecedor-compra.dialogs.bobina_58mm' | translate }}</label>
        </div>
        <div class="p-field-radiobutton">
          <p-radioButton name="formatoImpressaoCompra" value="BOBINA_80"
            [(ngModel)]="opcaoImpressaoFatura" inputId="compra-fmt-80">
          </p-radioButton>
          <label for="compra-fmt-80">{{ 'fornecedor-compra.dialogs.bobina_80mm' | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div class="dialog-wave-body fatura-dialog-loading" *ngIf="carregandoFatura">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton
      class="p-button-secondary"
      (click)="fecharDialogoFatura()">
      {{ 'fornecedor-compra.dialogs.fechar' | translate }} (Esc)
    </button>
    <button pButton
      icon="pi pi-print"
      [loading]="isImprimindoFatura"
      (click)="gerarPdfFaturaDialog()"
      [disabled]="carregandoFatura"
      #btnImprimirCompra>
      {{ 'fornecedor-compra.dialogs.imprimir' | translate }} (Ctrl+P)
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog de Visualizacao de Imagens do Item (carrossel) -->
<p-dialog
  *ngIf="itemImagensSelecionado"
  [(visible)]="imagensDialogVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px', maxWidth: '95vw', maxHeight: '90vh' }"
  [contentStyle]="{ overflow: 'auto' }"
  styleClass="lp-imagens-dialog"
  (onHide)="fecharImagensDoItem()"
  [header]="itemImagensSelecionado.nome">

  <app-item-imagens-carrossel
    [itemId]="itemImagensSelecionado.id"
    [imagemPrincipalUrl]="itemImagensSelecionado.imagem || undefined"
    [idEmpresa]="idEmpresa"
    [alt]="itemImagensSelecionado.nome">
  </app-item-imagens-carrossel>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
